import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/app/ui/assets/svg/create-faq.svg'


const _hoisted_1 = { class: "relative bg-white flex flex-col text-12px xxl:text-14px overflow-auto w-full" }
const _hoisted_2 = { class: "font-semibold self-center mr-10 text-20px whitespace-no-wrap text-black-lp-200 capitalize" }
const _hoisted_3 = {
  key: 0,
  class: "border rounded-xl border-gray-lp-1300 pt-4 pb-5 px-4 w-8/12 mt-4"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "flex flex-row" }, [
  /*#__PURE__*/_createVNode("div", { class: "w-1/6" }, [
    /*#__PURE__*/_createVNode("img", {
      src: _imports_0,
      class: "w-16 h-auto cursor-pointer",
      alt: "x"
    })
  ]),
  /*#__PURE__*/_createVNode("div", { class: "w-3/4" }, [
    /*#__PURE__*/_createVNode("p", { class: "text-14px xxl:text-16px font-bold font-montserrat text-gray-lp-300" }, " Fitur baru: Sekarang Anda bisa Pick Up langsung! "),
    /*#__PURE__*/_createVNode("p", { class: "text-12px xxl:text-14px font-normal font-montserrat text-gray-lp-800 pt-1 w-3/4" }, " Mau paketnya di Pick Up langsung? Tinggal klik \"Buat Pick Up langsung\", isi informasi Pick Up, dan selesai dah! ")
  ])
], -1)
const _hoisted_5 = { class: "flex h-screen justify-center overflow-auto" }
const _hoisted_6 = { class: "overflow-y-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_Header = _resolveComponent("Header")!
  const _component_ListPickupFilterBar = _resolveComponent("ListPickupFilterBar")!
  const _component_TableV2 = _resolveComponent("TableV2")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Header, { class: "items-center" }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_2, _toDisplayString(_ctx.getTitle), 1),
        _createVNode(_component_LpButton, {
          customClass: "py-2",
          textColor: "white",
          title: _ctx.$t('pickupCorporate.buttonCreateInstant'),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/pickup/list-pickup/create')))
        }, null, 8, ["title"])
      ]),
      _: 1
    }),
    (!_ctx.apiListData.errorType)
      ? (_openBlock(), _createBlock("div", _hoisted_3, [
          _hoisted_4
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_ListPickupFilterBar, {
      modelValue: _ctx.filter,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.filter = $event)),
      "error-type": _ctx.apiListData.errorType,
      onFilter: _ctx.onChangeAdvancedFilter,
      onReset: _ctx.onResetAdvancedFilter
    }, null, 8, ["modelValue", "error-type", "onFilter", "onReset"]),
    _createVNode("div", _hoisted_5, [
      _createVNode("div", _hoisted_6, [
        _createVNode(_component_TableV2, {
          loading: _ctx.apiListData.loading,
          borderTop: false,
          borderBottom: false,
          columns: _ctx.columns,
          data: _ctx.listData.data,
          isEmpty: _ctx.isEmpty,
          emptyHeaderMessage: _ctx.$t('pickupCorporate.emptyHeaderMessage'),
          emptyMessage: _ctx.$t('pickupCorporate.emptyMessage'),
          class: "my-2",
          errorCause: _ctx.apiListData.errorType,
          onClick: _ctx.onClickRow,
          isDetailAble: "",
          pagination: _ctx.listData.pagination,
          "onUpdate:pagination": _cache[3] || (_cache[3] = ($event: any) => (_ctx.listData.pagination = $event)),
          onRequest: _ctx.getListPickupList,
          onTryAgain: _ctx.getListPickupList,
          paginationStyle: "v3",
          totalColumnFreeze: 1,
          isRightFreeze: true,
          isPinnedScrollBottom: ""
        }, null, 8, ["loading", "columns", "data", "isEmpty", "emptyHeaderMessage", "emptyMessage", "errorCause", "onClick", "pagination", "onRequest", "onTryAgain"])
      ])
    ])
  ]))
}